import React, { memo } from "react";
import { resolveBackgroundStyle } from "./backgrounds";
import "./slideDesign.css";

const FX_PARTS = {
  aurora: 3,
  particles: 2,
  orbs: 4,
  mesh: 1,
  glow: 2,
  shapes: 3,
  depth: 3,
  spotlight: 1,
};

/**
 * Background Studio layer drawn underneath every canvas element.
 * `still` freezes animated effects (thumbnails, low-power, reduced motion).
 */
function SlideBackdrop({ background, still = false }) {
  const resolved = resolveBackgroundStyle(background);
  if (!resolved) return null;
  const { base, fx, overlay } = resolved;
  const parts = fx ? FX_PARTS[fx] || 1 : 0;

  return (
    <div
      className={`cine-backdrop${still ? " is-still" : ""}`}
      data-cine-backdrop=""
      aria-hidden="true"
    >
      <div className="cine-backdrop-base" style={base} />
      {fx ? (
        <div className={`cine-fx cine-fx-${fx}`}>
          {Array.from({ length: parts }, (_, i) => (
            <span key={i} className={`cine-fx-part cine-fx-part-${i + 1}`} />
          ))}
        </div>
      ) : null}
      {overlay ? <div className="cine-backdrop-overlay" style={overlay} /> : null}
    </div>
  );
}

export default memo(SlideBackdrop);
